export default __webpack_public_path__ + "static/media/wiki.4a385230.svg";